/**
 * Builds a WhatsApp click-to-chat link that preserves emoji.
 * wa.me redirects to api.whatsapp.com and re-encodes text, which corrupts
 * 4-byte emoji (🏨 → �). Linking api.whatsapp.com directly avoids the redirect.
 */
export function buildWhatsAppUrl(phone: string, text: string): string {
  const digits = (phone || '').replace(/\D/g, '');
  const params = [`phone=${digits}`, `text=${encodeURIComponent(text)}`];
  return `https://api.whatsapp.com/send?${params.join('&')}`;
}
